<template>
    <div v-if="this.isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <v-container>
            <v-form ref="rewardForm">
                <v-row style="margin-top: 20px;">
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardrecord.basicsaldate')" type="date" ref="basicsalarydate"
                            :rules="[rules.required]" v-model="formData.basicsalarydate" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardrecord.staffdetaildate')"  type="date" ref="staffdetailsdate"
                            :rules="[rules.required]" v-model="formData.staffdetailsdate" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardrecord.hirebeforedate')"  type="date" ref="hirebeforedate"
                            :rules="[rules.required]" v-model="formData.hirebeforedate" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardrecord.ceassatedaycutoff')"  type="date" ref="cessatecutoffdate"
                            :rules="[rules.required]" v-model="formData.cessatecutoffdate" dense 
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmrewardrecord.rewardsimulationprocesslogic')"  ref="logicid"
                            :rules="[rules.required]" v-model="formData.logicid" dense :items="logicOptionList"
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('columns.currency')" ref="currencyid"
                            :rules="[rules.required]" v-model="formData.currencyid" dense :items="currencyOptionList"
                             @change="changeCurrencyOption(formData.currencyid)" 
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('latenessdeduction.currencycode')" type="text" v-model="formData.currencycode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-autocomplete 
                            outlined :label="$t('pmrewardrecord.incrementrounding')" type="text" :items="roundingsOptionList"
                            v-model="formData.increroundingid" :rules="[rules.required]" dense
                            @change="changeIncrementRoundingHandler(formData.increroundingid)"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.incrementIsRounding">
                        <v-text-field
                            outlined
                            :label="$t('setuppayitem.roundto')"
                            type="number"
                            dense
                            :rules="this.incrementIsRounding ? [rules.required] : []"
                            v-model="formData.increroundto"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.incrementIsRounding">
                        <v-text-field
                            outlined 
                            :label="$t('pmrewardrecord.minamt')"
                            type="number"
                            dense
                            v-model="formData.increminamt"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.incrementIsRounding">
                        <v-text-field
                            outlined
                            :label="$t('pmrewardrecord.maxamt')"
                            type="number"
                            dense
                            v-model="formData.incremaxamt"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-autocomplete 
                            outlined :label="$t('pmrewardrecord.bonusrounding')" type="text" :items="roundingsOptionList"
                            v-model="formData.bonusroudingid" :rules="[rules.required]" dense
                            @change="changeBonunsRoundingHandler(formData.bonusroudingid)"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.bonusIsRounding">
                        <v-text-field
                            outlined
                            :label="$t('setuppayitem.roundto')"
                            type="number"
                            dense
                            :rules="this.bonusIsRounding ? [rules.required] : []"
                            v-model="formData.bonusroundto"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.bonusIsRounding">
                        <v-text-field
                            outlined
                            :label="$t('pmrewardrecord.minamt')"
                            type="number"
                            dense
                            v-model="formData.bonusminamt"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8" v-if="this.bonusIsRounding">
                        <v-text-field
                            outlined
                            :label="$t('pmrewardrecord.maxamt')"
                            type="number"
                            dense
                            v-model="formData.bonusmaxamt"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <app-formbuttons 
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler" 
                />
            </v-form>
        </v-container>
        <div>
            <app-success
                v-if="isSuccessDialogOpen"
                :key="successkey"
                :parentObject="successDialogData"
                
            />
        </div>
    </div>
</template>

<script>
//import moment from 'moment';
import SuccessDialog from "../../../components/common/SuccessDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-success": SuccessDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                rewardrecordid: this.parentObject.rewardrecordid,

                id: this.parentObject?.data?.id || null,
                basicsalarydate: this.parentObject?.data?.basicsalarydate || null,
                staffdetailsdate: this.parentObject?.data?.staffdetailsdate || null,
                hirebeforedate: this.parentObject?.data?.hirebeforedate || null,
                cessatecutoffdate: this.parentObject?.data?.cessatecutoffdate || null,
                logicid: this.parentObject?.data?.logicid || null,
                currencyid: this.parentObject?.data?.currencyid || null,
                increroundingid: this.parentObject?.data?.increroundingid || null,
                increroundto: this.parentObject?.data?.increroundto || null,
                increminamt: this.parentObject?.data?.increminamt || null,
                incremaxamt: this.parentObject?.data?.incremaxamt || null,
                bonusroudingid: this.parentObject?.data?.bonusroudingid || null,
                bonusroundto: this.parentObject?.data?.bonusroundto || null,
                bonusminamt: this.parentObject?.data?.bonusminamt || null,
                bonusmaxamt: this.parentObject?.data?.bonusmaxamt || null,
                stamp: this.parentObject?.data?.stamp || 0,
                updatedby: this.$store.getters.userId || null,
            },

            defaultForm: {
                rewardrecordid: this.parentObject.rewardrecordid,

                id: this.parentObject?.data?.id || null,
                basicsalarydate: this.parentObject?.data?.basicsalarydate || null,
                staffdetailsdate: this.parentObject?.data?.staffdetailsdate || null,
                hirebeforedate: this.parentObject?.data?.hirebeforedate || null,
                cessatecutoffdate: this.parentObject?.data?.cessatecutoffdate || null,
                logicid: this.parentObject?.data?.logicid || null,
                currencyid: this.parentObject?.data?.currencyid || null,
                increroundingid: this.parentObject?.data?.increroundingid || null,
                increroundto: this.parentObject?.data?.increroundto || null,
                increminamt: this.parentObject?.data?.increminamt || null,
                incremaxamt: this.parentObject?.data?.incremaxamt || null,
                bonusroudingid: this.parentObject?.data?.bonusroudingid || null,
                bonusroundto: this.parentObject?.data?.bonusroundto || null,
                bonusminamt: this.parentObject?.data?.bonusminamt || null,
                bonusmaxamt: this.parentObject?.data?.bonusmaxamt || null,
                stamp: this.parentObject?.data?.stamp || 0,
                updatedby: this.$store.getters.userId || null,
            },

            isEdit: this.parentObject.isEdit,
            errMsg: '',
            isErr: false,
            isLoading: true,
            isSuccessDialogOpen: false,
            successDialogData: {
                isSuccess: false,
                messageSuccess: "",
            },
            successkey: 0,//this is use to force open and close the confirm dialog
            

            currencyOptionList: [], // take necessary data only from Full
            currencyOptionFull: [],// get full data from database
            logicOptionList: [], // take necessary data only from Full
            logicOptionFull: [],// get full data from database

            //rounding part
            roundingsOptionList: [],
            roundingsOptionFull: [],// get full data from database
            incrementIsRounding: false,
            bonusIsRounding: false,
            incrementRoundingCode: null, // not showing , use to turn onoff column
            bonusRoundingCode: null,
        }
    },

    methods: {        
        async saveHandler() {
            const isValid = await this.$refs.rewardForm.validate();
            if (!isValid) {
                 // Form validation failed
                this.isErr = true;
                this.errMsg = 'Please fill all required fields correctly.';
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }
            if (//when saving, check rounding code, if no match ,then clear the related amount
                this.incrementRoundingCode != "ROUNDOFF" &&
                this.incrementRoundingCode != "ROUNDUP" &&
                this.incrementRoundingCode != "ROUNDDOWN"
            ) {
                this.formData.increroundto = null;
                this.formData.increminamt = null;
                this.formData.incremaxamt = null;
            }

            if (
                this.bonusRoundingCode != "ROUNDOFF" &&
                this.bonusRoundingCode != "ROUNDUP" &&
                this.bonusRoundingCode != "ROUNDDOWN"
            ) {
                this.formData.bonusroundto = null;
                this.formData.bonusminamt = null;
                this.formData.bonusmaxamt = null;
            }

            
            if (this.isEdit) { // Edit/update
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }

                    const res = await this.$store.dispatch('put', {
                        url: "/pmrewardinstruction/" + this.formData.rewardrecordid,
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        this.defaultForm={... this.formData};//set as new default
                        this.isSuccessDialogOpen= false;
                        this.successkey++;
                        this.successDialogData.isSuccess = true;
                        this.successDialogData.messageSuccess = this.$t('pmrewardrecord.instructionupdate');
                        this.isSuccessDialogOpen = true;
                    }
            }
            else{//create
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                        console.error("❌ No permission to add");
                        return false;
                    }

                    const res = await this.$store.dispatch('post', {
                        url: "/pmrewardinstruction/create",
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        this.defaultForm={... this.formData};//set as new default
                        this.isEdit= true;
                        this.isSuccessDialogOpen= false;
                        this.successkey++;
                        this.successDialogData.isSuccess = true;
                        this.successDialogData.messageSuccess = this.$t('pmrewardrecord.instructioncreate')
                        this.isSuccessDialogOpen = true;
                       
                    }
            }
                
        },

        async cancelHandler() {
            this.formData = { ...this.defaultForm };//reset to default
            await this.loadCurrencyListHandler();
            await this.loadLogicListHandler();
            await this.loadRoundingListHandler();
        },

        async loadCurrencyListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/currency/all" });
                this.currencyOptionFull = res.data.rec;
                this.currencyOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.currencyOptionList.push({
                            text: res.data.rec[i].crcydesc,
                            value: res.data.rec[i].id,
                        });
                }

                if (this.formData.currencyid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeCurrencyOption(this.formData.currencyid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeCurrencyOption(id) {
            let item = this.currencyOptionFull.find((item) => item.id === id);
            this.formData.currencycode = item.crcycode;
        },
        
        async loadLogicListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardlogics" });
                this.logicOptionFull = res.data.rec;
                this.logicOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.logicOptionList.push({
                            text: res.data.rec[i].logicname,
                            value: res.data.rec[i].id,
                        });
                }
         
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadRoundingListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/rounding/all" });
                this.roundingsOptionFull = res.data.rec;
                this.roundingsOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.roundingsOptionList.push({
                            text: res.data.rec[i].roundingdesc,
                            value: res.data.rec[i].id,
                        });
                }

                if (this.formData.increroundingid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeIncrementRoundingHandler(this.formData.increroundingid);
                }

                if (this.formData.bonusroudingid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeBonunsRoundingHandler(this.formData.bonusroudingid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeIncrementRoundingHandler(id) {
            let item = this.roundingsOptionFull.find((item) => item.id === id);

            this.incrementRoundingCode = item.roundingcode;

            if (
                this.incrementRoundingCode == "ROUNDOFF" ||
                this.incrementRoundingCode == "ROUNDUP" ||
                this.incrementRoundingCode == "ROUNDDOWN"
            ) {
                this.incrementIsRounding = true;
            } else {
                this.incrementIsRounding = false;
            }
        },

        changeBonunsRoundingHandler(id) {
            let item = this.roundingsOptionFull.find((item) => item.id === id);

            this.bonusRoundingCode = item.roundingcode;

            if (
                this.bonusRoundingCode == "ROUNDOFF" ||
                this.bonusRoundingCode == "ROUNDUP" ||
                this.bonusRoundingCode == "ROUNDDOWN"
            ) {
                this.bonusIsRounding = true;
            } else {
                this.bonusIsRounding = false;
            }
        },
    },
    async mounted() {
        try {
            await this.loadCurrencyListHandler();
            await this.loadLogicListHandler();
            await this.loadRoundingListHandler();        
            this.isLoading = false;
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }

}
</script>
